import { CSSInterpolation } from '@mui/material'

export const customStylesMuiButtongroup: CSSInterpolation = {
  fontSize: '14px',
  borderRadius: '8px',
  background: '#fff',
  borderColor: '#ECECF0',
}
